import axiosInstance from "./instance";

const instance = axiosInstance();
const headers = new Headers({ 'Content-Type': 'application/octet-stream' });


export const addUserDetails = async (data) => {
    try {
        const response = await instance.post(`/users/education-loan-user-details`,data);
        return response;
    } catch (error) {
        return error;
    }
}
export const updateUserDetails = async (id,data) => {
    try {
        const response = await instance.put(`/users/education-loan-user-details/${id}`,data);
        return response;
    } catch (error) {
        return error;
    }
}
export const getAllDeals = async (id) => {
    try {
        const response = await instance.get(`/users/education-loan-user-details/${id}`);
        return response;
    } catch (error) {
        return error;
    }
}
export const uploadUserProfile = async (userId, type, file) => {
    try {        
        const response = await instance.post(`users/education-loan-user-details/${userId}/${type}/upload`, file,{
            headers: headers
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const addCoApplicantsDetails = async (data) => {
    try {        
        const response = await instance.post(`users/education-loan-co-applicant-details`, data);
        return response;
    } catch (error) {
        return error;
    }
}
export const updateCoApplicantsDetails = async (id,data) => {
    try {        
        const response = await instance.put(`users/education-loan-co-applicant-details/${id}`, data);
        return response;
    } catch (error) {
        return error;
    }
}
export const getCoApplicantByUserId = async (id) => {
    try {
        const response = await instance.get(`/users/education-loan-co-applicant-details/user/${id}`);
        return response;
    } catch (error) {
        return error;
    }
}
export const uploadCoApplicantsDetails = async (userId, type, file) => {
    try {        
        const response = await instance.post(`users/education-loan-co-applicant-details/${userId}/${type}/upload`, file,{
            headers: headers
        });
        return response;
    } catch (error) {
        return error;
    }
}
export const getUserByUserId = async (id) => {
    try {
        const response = await instance.get(`/users/education-loan-user-details/user/${id}`);
        return response;
    } catch (error) {
        return error;
    }
}

export const addReferenceDetails = async (data) => {
    try {        
        const response = await instance.post(`education-loan/reference`, data);
        return response;
    } catch (error) {
        return error;
    }
}
export const updateReferenceDetails = async (id,data) => {
    try {        
        const response = await instance.post(`education-loan/reference/${id}`, data);
        return response;
    } catch (error) {
        return error;
    }
}
export const getReferenceByUserId = async (id) => {
    try {
        const response = await instance.get(`education-loan/reference/user/${id}`);
        return response;
    } catch (error) {
        return error;
    }
}